import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder,FormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AutotextService } from 'src/app/autotext.service';
import { ExamsService } from 'src/app/exams.service';

@Component({
    selector: 'app-cardio-flow-meas',
    templateUrl: './cardio-flow-meas.component.html',
    styleUrls: ['./cardio-flow-meas.component.scss'],
    standalone: false
})
export class CardioFlowMeasComponent implements OnInit, OnDestroy {
  FLOWMEAS=['CCA', 'Bulb', 'ICA Prox', 'Mid ICA', 'ECA', 'VA', 'ICA/CCA']
  flowmeasForm: UntypedFormGroup;
  mediaSub: Subscription;
  constructor(public es:ExamsService, private fb:UntypedFormBuilder,public atS:AutotextService) { }

  ngOnInit() {
    this.resetForm();
    this.es.getSRs();

    if (!this.es.isClosed)
      this.mediaSub = this.es.mediaArrived$.subscribe((mediatype) => {
        if (mediatype == 'html')
          this.es.fillForm(this.flowmeasForm, 'flowmeas', false, true);
      });
  }

  ngOnDestroy() {
    if (this.mediaSub) this.mediaSub.unsubscribe();
  }

  resetForm(){
    let forms= {
      Reason:[''],
      Summary:[''],
      CCALeft: [''],
      ICALeft: [''],
      ECALeft: [''],
      VALeft: [''],
      CCARight: [''],
      ICARight: [''],
      ECARight: [''],
      VARight: [''],
    }
    for(let i of this.FLOWMEAS){
      forms[this.getDb(i)+"PSVLEFT"] = [''];
      forms[this.getDb(i)+"PSVRIGHT"] = [''];

      forms[this.getDb(i)+"EDVLEFT"] = [''];
      forms[this.getDb(i)+"EDVRIGHT"] = [''];
    }
    forms["IMTRIGHT"] = [''];
    forms["IMTLEFT"] = [''];


    this.flowmeasForm = this.fb.group(forms);
    this.es.fillForm(this.flowmeasForm, 'flowmeas', false, true)

  }
  getDb(str){
    return str.replace(" ", "");
  }

}
